import React from 'react';
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import { connect } from 'react-redux';
import { withStyles} from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { setData } from '../../actions/index';
import CalendarHeader from '../parts/CalendarHeader';
import HomeworkDetailsDialog from '../parts/Homework/HomeworkDetailsDialog';
import HomeworkGroup from '../parts/Homework/HomeworkGroup';
import { getHomeworkStatus } from '../../helpers';

const styles = theme => ({
  singleStatusSection: {
    marginBottom: 20,
  },
  statusHeading: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'capitalize',
    color: '#394f5a',
    marginBottom: 20,
  },
  mobileNotice: {
    color: 'rgb(13, 60, 97)',
    background: 'rgb(232, 244, 253)',
    paddingTop: 6,
    paddingLeft: 16,
    paddingBottom: 6,
    paddingRight: 16,
    lineHeight: 1.43,
    borderRadius: 4,
    marginBottom: 16,
    fontSize: 13,
  },
  metaBadge: {
    display: isMobileApp
      ? 'block'
      : 'inline-block',
    backgroundColor: '#f5f5f5',
    color: '#212121',
    padding: '5px 20px',
    margin: isMobileApp
      ? '20px 0'
      : '0 20px 20px 0',
    borderRadius: 4,
  },
  metaBadgeCheckbox: {
    padding: '3px 20px',
    margin: isMobileApp
      ? '20px 0'
      : '0 20px 18px 0',
    position: 'relative',
    top: isMobileApp
      ? 0
      : -2,
  },
  radio: {
    marginBottom: 10,
  },
  headerLabel: {
    fontFamily: 'inherit',
    letterSpacing: 'inherit',
  },
});

const mapStateToProps = state => {
  return {
    user: state.user,
    selectedPupil: state.selectedPupil,
    defaultDateRangeHomework: state.defaultDateRangeHomework,
    openModal: state.openModal,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

class HomeworkPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateStart: null,
      dateEnd: null,
      homeworks: [],
      homeworksLoading: false,
      homeworksLoaded: false,
      homeworksPerStatus: {},
      homeworksMeta: {},
      homeworksDisplayType: null,
      isDialogOpen: false,
      selectedHomework: {},
      hasHomeworkWithUploads: false,
      allowPupilAttachments: false,
    };

    this.axiosCancel = null;

    this.checkModal = this.checkModal.bind(this);
    this.onRangeChanged = this.onRangeChanged.bind(this);
    this.onDetailsButtonClick = this.onDetailsButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onAllowPupilAttachmentsCheckbox = this.onAllowPupilAttachmentsCheckbox.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.reloadHomeworkData = this.reloadHomeworkData.bind(this);
    this.processHomeworks = this.processHomeworks.bind(this);
  }

  componentDidMount() {
    const {
      defaultDateRangeHomework,
    } = this.props;

    if (defaultDateRangeHomework !== null) {
      this.setState({
        dateStart: defaultDateRangeHomework[0],
        dateEnd: defaultDateRangeHomework[1],
      }, () => {
        this.reloadData();
      });
    } else {
      this.reloadData();
    }
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.openModal !== prevProps.openModal) {
      this.checkModal();
    }
  }

  checkModal() {
    const {
      openModal,
    } = this.props;
    const {
      homeworks,
      homeworksLoaded,
    } = this.state;

    if (typeof this.lastOpenModal === 'undefined') {
      this.lastOpenModal = false;
    }

    if (this.lastOpenModal === openModal) {
      return;
    }

    if (!openModal) {
      this.onDialogClose();
    } else {
      const openModalId = parseInt(openModal.replace('hw_', ''));
      for (let i = 0; i < homeworks.length; i++) {
        if (homeworks[i].id === openModalId) {
          this.onDetailsButtonClick(homeworks[i], true);
          break;
        }
      }
    }

    if (homeworksLoaded) {
      this.lastOpenModal = openModal;
    }
  }

  onRangeChanged(range) {
    const dateStart = range[0].format('YYYY-MM-DD');
    const dateEnd = range[1].format('YYYY-MM-DD');

    this.setState({
      dateStart,
      dateEnd,
    }, () => {
      this.reloadData();
    });

    this.props.setData(range, 'defaultDateRangeHomework');
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;
    const {
      dateStart,
      dateEnd,
      homeworksDisplayType,
      allowPupilAttachments,
    } = this.state;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      homeworksLoading: true,
    });
    this.processHomeworks();

    let query = {};

    if (homeworksDisplayType) {
      query.display_date = homeworksDisplayType;
    }

    if (allowPupilAttachments) {
      query.allow_pupil_attachments = 'yes';
    }

    if (dateStart && dateEnd) {
      query.from = moment(dateStart).format('YYYY-MM-DD');
      query.to = moment(dateEnd).format('YYYY-MM-DD');
    }

    return axios
      .get(
        `${window.apiUrl}/homeworks/${selectedPupil.id}?${qs.stringify(query)}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {

          this.setState({
            homeworks: response.data.data,
            homeworksMeta: response.data.meta,
            homeworksDisplayType: response.data.meta.display_type,
            dateStart: response.data.meta.start_date,
            dateEnd: response.data.meta.end_date,
          });
          this.processHomeworks();
        }

        this.setState({
          homeworksLoading: false,
          homeworksLoaded: true,
        });

        this.checkModal();
      })
      .catch((thrown) => {});
  }

  reloadHomeworkData() {
    this.reloadData()
      .then(() => {
        const {
          homeworks,
          selectedHomework,
        } = this.state;

        let newSelectedHomework = {};

        for (let i = 0; i < homeworks.length; i++) {
          if (homeworks[i].id === selectedHomework.id) {
            newSelectedHomework = homeworks[i];
            break;
          }
        }

        this.setState({
          selectedHomework: newSelectedHomework,
        });
      })
      .catch((thrown) => {});
  }

  processHomeworks() {
    const {
      homeworks,
    } = this.state;
    const homeworksPerStatus = {
      todo: [],
      completed: [],
      late: [],
      not_submitted: [],
      submitted: [],
    };

    let hasHomeworkWithUploads = false;

    for (let i = 0; i < homeworks.length; i++) {
      let homework = homeworks[i];

      const homeworkStatus = getHomeworkStatus(homework);

      if (homework.status?.allow_attachments === 'yes') {
        hasHomeworkWithUploads = true;
      }

      if (Object.keys(homeworksPerStatus).indexOf(homeworkStatus) !== -1) {
        homeworksPerStatus[homeworkStatus].push(homework);
      }
    }

    this.setState({
      homeworksPerStatus,
      hasHomeworkWithUploads,
    });
  }

  onDetailsButtonClick(homework, triggeredInsideModalCheck) {
    const {
      selectedPupil
    } = this.props;

    this.setState({
      isDialogOpen: true,
      selectedHomework: homework,
    }, () => {
      if (homework.status?.first_seen_date) {
        return;
      }

      // This will prevent invoking itself twice - once from the event itself
      // and once from the this.checkModal() function which is called, if modal is opened.
      // It still is, but by setting this.lastOpenModal it will stop the excecution earlier.
      if (triggeredInsideModalCheck) {
        this.lastOpenModal = 'hw_' + homework.id;
      }
      this.props.setData('hw_' + homework.id, 'openModal');

      axios.post(`${window.apiUrl}/markhomeworkasseen/${homework.id}`, qs.stringify({
        pupil_id: selectedPupil.id,
      }))
        .then(() => {
          if (!homework.status) {
            return;
          }

          homework.status.first_seen_date = moment().format();
        })
        .catch((thrown) => {});
    });
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
      selectedHomework: {},
    }, () => {
      this.props.setData(false, 'openModal');
    });
  }

  onRadioChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      this.reloadData();
    });
  }

  onAllowPupilAttachmentsCheckbox() {
    this.setState({
      allowPupilAttachments: !this.state.allowPupilAttachments,
    }, () => {
      this.reloadData();
    });
  }

  render() {
    const {
      homeworksMeta,
      homeworksPerStatus,
      homeworksDisplayType,
      dateStart,
      dateEnd,
      isDialogOpen,
      selectedHomework,
      hasHomeworkWithUploads,
      allowPupilAttachments,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="homework-page">
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <CalendarHeader
              dateText={homeworksDisplayType === 'issue_date'
                ? `${t('Issue date')}:`
                : `${t('Due date')}:`}
              dateFormat={dateFormat}
              dateStart={dateStart}
              dateEnd={dateEnd}
              onRangeChanged={this.onRangeChanged}
              includeFutureRanges
              useSuspense={false}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              className={`radio-issue-date ${classes.radio}`}
              control={(
                <Radio
                  checked={homeworksDisplayType === 'issue_date'}
                  onChange={this.onRadioChange}
                  value="issue_date"
                  name="homeworksDisplayType"
                  aria-label={t('Issue date')}
                />
              )}
              label={t('Show by issue date')}
            />
            <FormControlLabel
              className={`radio-due-date ${classes.radio}`}
              control={(
                <Radio
                  checked={homeworksDisplayType === 'due_date'}
                  onChange={this.onRadioChange}
                  value="due_date"
                  name="homeworksDisplayType"
                  aria-label={t('Due date')}
                />
              )}
              label={t('Show by due date')}
            />
          </Grid>
        </Grid>
        {hasHomeworkWithUploads && (
          (typeof isIosApp !== 'undefined' && isIosApp) ||
          (typeof isAndroidApp !== 'undefined' && isAndroidApp)
        )
          ? (
            <Grid container>
              <Grid item>
                <div className={classes.mobileNotice}>
                  {t(
                    'Some of the homework requires you to upload your completed tasks. \n' +
                    'If homework file submission is not possible on your mobile device please use your Pupil Account on a computer. ' +
                    'Login with the same details at www.classcharts.com/student. ' +
                    'You can find your code under the My code menu point.'
                  )}
                </div>
              </Grid>
            </Grid>
          )
          : ''}
        <div>
          <div className={`meta-badge-tasks-due ${classes.metaBadge}`}>
            <b>{homeworksMeta.this_week_due_count ? homeworksMeta.this_week_due_count : 0} </b>
            <span>{homeworksMeta.this_week_due_count === 1
              ? t('task due this week')
              : t('tasks due this week')}</span>
          </div>
          <div className={`meta-badge-tasks-completed ${classes.metaBadge}`}
            style={{ backgroundColor: '#A9E2AC' }}>
            <b>{homeworksMeta.this_week_completed_count ? homeworksMeta.this_week_completed_count : 0} </b>
            <span>{homeworksMeta.this_week_completed_count === 1
              ? t('task submitted/completed')
              : t('tasks submitted/completed')}</span>
          </div>
          <div className={`meta-badge-tasks-remaining ${classes.metaBadge}`}
            style={{ backgroundColor: '#FF8F86' }}>
            <b>{homeworksMeta.this_week_outstanding_count ? homeworksMeta.this_week_outstanding_count : 0} </b>
            <span>{homeworksMeta.this_week_outstanding_count === 1
              ? t('task remaining this week')
              : t('tasks remaining this week')}</span>
          </div>
          {homeworksMeta.allow_attachments && (
            <div className={`meta-badge-requires-submission ${classes.metaBadge} ${classes.metaBadgeCheckbox}`}
              style={{ backgroundColor: '#CDF7FF' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    checked={allowPupilAttachments}
                    onChange={this.onAllowPupilAttachmentsCheckbox}
                    style={{ padding: '0 9px 0 0' }}
                  />
                }
                label={t('Requires submission?')}
                classes={{
                  label: classes.headerLabel,
                }}
              />
            </div>
          )}
        </div>
        {Object.keys(homeworksPerStatus).map((status) => {
          return (
            <HomeworkGroup
              key={status}
              status={status}
              entries={homeworksPerStatus[status]}
              homeworksMeta={homeworksMeta}
              onEntryClick={this.onDetailsButtonClick}
              reloadHomeworkData={this.reloadHomeworkData}
              useSuspense={false}
            />
          );
        })}
        <HomeworkDetailsDialog
          isDialogOpen={isDialogOpen}
          onDialogClose={this.onDialogClose}
          homework={selectedHomework}
          homeworksMeta={homeworksMeta}
          reloadHomeworkData={this.reloadHomeworkData}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(HomeworkPage)))
);
